import type { FaireProductEntity } from "../../entity_types/product";

export const p_1beqghnpbf: FaireProductEntity = {
  token: "p_1beqghnpbf",
  type: "product",
  name: "Feather Coconut Bowl",
  brandName: "Rainforest Bowls",
  imageUrl:
    "https://cdn.faire.com/fastly/05a653f5c8ff6d794f243bae9beb2f05e104aa47b4f93fbf5507e75c160cabea.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/014490c47bb5fc0e93149a1905367b31769d4b9be0894fb8e3b281e198d96ef5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
